import { IHistoryList } from "@/common/services/types";
import ArrowIcon from "@/common/images/icons/arrow_top_right.svg?react";

import "./SearchHistory.scss";

interface IProps {
  itemData: IHistoryList;
  onClick: (value: string) => void;
}

export const SearchHistory = ({ itemData, onClick }: IProps) => {
  const handleClick = () => {
    onClick(itemData.text);
  };

  return (
    <li className="SearchHistory" onClick={handleClick}>
      <div className="SearchHistory-ClockIcon" />

      <div className="SearchHistory-Cnt">
        <h4>{itemData.text}</h4>
      </div>

      <ArrowIcon className="SearchHistory-Arrow" />
    </li>
  );
};
